import React from 'react';
import Collection from './WebSiteImages/Collection';

const Gallery = () => {
    return (
        <div className="container mb-4">
            <h1>Our Environments</h1>
            <hr />
            <Collection></Collection>
        </div>
    );
};

export default Gallery;